// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";

import iView from "iview";
import "iview/dist/styles/iview.css";

Vue.config.productionTip = false;
Vue.use(iView);
/* eslint-disable no-new */

let routerPaths = [];

function getAllPaths(routes) {
  if (!routes || routes.length === 0) return;
  for (let i = 0, l = routes.length; i < l; i++) {
    let obj = routes[i];
    if (routerPaths.indexOf(obj.path) < 0) {
      routerPaths.push(obj.path);
    }
    if (obj.children && obj.children.length > 0) {
      getAllPaths(obj.children);
    }
  }
}

getAllPaths(router.options.routes);

// navigation-guards
router.beforeEach((to, from, next) => {
  if (routerPaths.indexOf(to.path) < 0) {
    next("/");
  } else {
    next();
  }
});

Vue.prototype.$global = {
  siteName: "亿景排班"
};
function windowResize() {
  Vue.prototype.$global.isMobile =
    window.document.documentElement.clientWidth <= 768;
}
window.addEventListener("resize", windowResize);
windowResize();

/* eslint-disable */
(function(window) {
  if (!Vue.prototype.$global.isMobile) {
    return;
  }
  setRem();
  function setRem() {
    var html = document.documentElement;
    var width = html.clientWidth;
    if (width > 790) {
      width = 790;
    }
    var fontSize = width / 37.5 + "px";
    Vue.prototype.$global.fontSize = parseFloat(fontSize.replace("px", ""));
    html.style.fontSize = fontSize;
  }
  var _resize = "orientation" in window ? "deviceorientation" : "resize";
  window.addEventListener(_resize, setRem, false);
})(window);
/* eslint-enable */

new Vue({
  created() {
    window.addEventListener("beforeunload", this.beforePageDestroyed);
  },
  methods: {
    beforePageDestroyed: function(event) {
      console.log("beforePageDestroyed");
      // sessionStorage.setItem("token", null);
      // sessionStorage.setItem("userId", null);
    }
  },
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js